import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import axios from 'axios';
import { ArrowLeft, Ticket } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function CustomerCoupons() {
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/coupons/my`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCoupons(response.data);
    } catch (error) {
      console.error('Error fetching coupons:', error);
    }
  };

  return (
    <div className="min-h-screen bg-cream pt-6 pb-12" data-testid="customer-coupons-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={() => navigate('/customer/events')}
          variant="ghost"
          className="mb-6"
          data-testid="back-button"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Events
        </Button>

        <h1 className="font-playfair font-bold text-4xl text-primary mb-8">My Credits</h1>

        {coupons.length === 0 ? (
          <Card className="p-12 text-center">
            <Ticket className="w-16 h-16 mx-auto mb-4 text-amber-600" />
            <p className="font-outfit text-gray-600">No coupons yet. Submit receipts to earn coupons!</p>
          </Card>
        ) : (
          <div className="space-y-8">
            {coupons.map((item) => (
              <Card key={item.event.event_id} className="p-6">
                <h2 className="font-playfair font-bold text-2xl text-primary mb-4">{item.event.event_name}</h2>
                <p className="font-outfit text-lg mb-4">Incentive Credits: <span className="font-bold text-amber-600">{item.coupons.length}</span></p>
                
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {item.coupons.map((coupon) => (
                    <div
                      key={coupon.coupon_id}
                      className="bg-gradient-to-r from-amber-50 to-amber-100 border-2 border-dashed border-amber-300 rounded-lg p-3 text-center"
                      data-testid={`coupon-${coupon.coupon_id}`}
                    >
                      <Ticket className="w-6 h-6 mx-auto mb-1 text-amber-600" />
                      <p className="font-outfit text-xs text-gray-700 font-mono">{coupon.coupon_id}</p>
                    </div>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}